import {ErrorWithRetry} from '@github-ui/error-with-retry'
import {StopIcon} from '@primer/octicons-react'
import {Octicon} from '@primer/react/deprecated'

import {MESSAGES} from '../../constants/messages'
import styles from './IssueViewerError.module.css'

const GenericError = ({retry}: {retry: () => void}) => (
  <ErrorWithRetry message={MESSAGES.couldNotLoad} retry={retry} className={styles.ErrorWithRetry} />
)

const NotFoundError = () => (
  <div className={styles.notFoundContainer}>
    <Octicon size="medium" icon={StopIcon} className={styles.errorIcon} />
    <div className={styles.errorMessageContainer}>
      <h2>{MESSAGES.issueNotFound}</h2>
      <span className={styles.descriptionText}>{MESSAGES.issueNotFoundDescription}</span>
    </div>
  </div>
)

export const renderGenericError = (retry: () => void) => <GenericError retry={retry} />

export const renderIssueViewerErrors = (retry: () => void, error: Error) => {
  if (error.message.includes('NOT_FOUND')) {
    return <NotFoundError />
  }

  return renderGenericError(retry)
}
